import type { FC } from 'react';
import React, { createContext, useContext, useState } from 'react';

import type { TQuestions } from '../../models';

import type { IProps, IQuizContext } from './models';

const DEFAULT_STATE = {
    questions: {},
    questionsCount: 0,
    questionIndex: 1,
} as IQuizContext;

const Context = createContext<IQuizContext>(DEFAULT_STATE);

export const useQuizContext = () => useContext(Context);

/** Опрос */
export const Quiz: FC<IProps> = ({ children }) => {
    const [questions, setQuestions] = useState(DEFAULT_STATE.questions);
    const [questionsCount, setQuestionsCount] = useState(DEFAULT_STATE.questionsCount);
    const [questionIndex, setQuestionIndex] = useState(DEFAULT_STATE.questionIndex);

    const updateQuestions = (newQuestions: TQuestions) =>
        setQuestions(prev => ({ ...prev, ...newQuestions }));

    return (
        <Context.Provider
            value={{
                updateQuestions,
                updateQuestionsCount: setQuestionsCount,
                updateQuestionIndex: setQuestionIndex,
                questions,
                questionsCount,
                questionIndex,
            }}
        >
            {children}
        </Context.Provider>
    );
};
